import { render } from "./App.vue?vue&type=template&id=55c15236"
const script = {}

import "./App.vue?vue&type=style&index=0&id=55c15236&lang=scss"

import exportComponent from "/opt/jenkins/workspace/Application deploy/prod-fe-cn-social-media-wph-h5-deployment/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__